import { useCallback, useEffect, useState } from 'react';

export const MATHLIVE_SCRIPT_ID = 'mathliveScriptId';
// const mathLiveUrl = '//unpkg.com/mathlive/dist/mathlive.min.js'
const mathLiveUrl = '//unpkg.com/mathlive@0.96.2/dist/mathlive.min.js';

const useMathLive = () => {
  const [mathLiveReady, setReady] = useState(false);
  const onLoadDone = useCallback(() => {
    (function retry(times) {
      !window.MathLive ? setTimeout(() => retry(times - 1), 200) : setReady(true);
    })(2);
  }, [setReady]);

  const loadScript = useCallback(
    (url, id) => {
      if (isLoadedMathlive()) {
        // == Ya esta cargado
        onLoadDone();
      } else {
        // == Lemonade es el encargado de cargar Mathlive ya que no lo ha definido un host
        if (!document.getElementById(id)) {
          const script = document.createElement('script');
          script.src = url;
          script.id = id;
          script.async = true;
          script.addEventListener('load', onLoadDone);
          document.body.appendChild(script);
        } else {
          onLoadDone();
        }
      }
    },
    [onLoadDone]
  );

  useEffect(() => {
    loadScript(mathLiveUrl, MATHLIVE_SCRIPT_ID);
  }, []);

  function isLoadedMathlive() {
    return typeof window.MathLive !== 'undefined';
  }

  return { mathLiveReady };
};
export default useMathLive;
